import { useMemo } from "react";
import { findCurrency, formatCurrencyPreview } from "../utils/currencyList";

export function useCurrencyMeta(code) {
  return useMemo(() => {
    const meta = findCurrency(code);
    if (!meta) {
      return {
        code: code || null,
        digits: 2,
        symbol: code || "",
        formatSample: (amount) => `${code || ""} ${amount}`,
      };
    }
    return {
      code: meta.code,
      digits: meta.digits,
      symbol: meta.symbol,
      formatSample: (amount) =>
        formatCurrencyPreview(meta.code, amount),
    };
  }, [code]);
}
